var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuscaArquivoBranca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66671 0.666656H2.00004C1.08337 0.666656 0.341708 1.41666 0.341708 2.33332L0.333374 15.6667C0.333374 16.5833 1.07504 17.3333 1.99171 17.3333H12C12.9167 17.3333 13.6667 16.5833 13.6667 15.6667V5.66666L8.66671 0.666656ZM12 15.6667H2.00004V2.33332H7.83337V6.49999H12V15.6667ZM3.66671 11.5083L4.84171 12.6833L6.16671 11.3667V14.8333H7.83337V11.3667L9.15837 12.6917L10.3334 11.5083L7.00837 8.16666L3.66671 11.5083Z",
    fill: "#bdbdbd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuscaArquivoBranca);
export default __webpack_public_path__ + "static/media/busca_arquivo_branca.3846e7f9099f010c56d8f66fe8e8d62c.svg";
export { ForwardRef as ReactComponent };